import React, { useContext, useEffect, useRef, useState } from "react";
import NavSub from "../components/NavSub";
import "../Styles/QualityControl.css";
import "../Styles/common.css";
import { AuthContext } from "../context/AuthContext";
import { Box, FormControl, MenuItem, Select } from "@mui/material";
import isGuestUser from "../utils/guestUser";
import { taskApiUrl } from "../utils/GetUrl";
import ToastComponent from "../components/ToastComponent";

const QualityControl = () => {
  const [selectedStatus2, setSelectedStatus2] = useState("Select Status");
  const [statuses, setStatuses] = useState({});
  const [statuses2, setStatuses2] = useState({});
  const [qcPointsEmployee, setQcPointsEmployee] = useState([]);
  const [qcPointsEmployee2, setQcPointsEmployee2] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(new Date().toISOString());
  const toastRef = useRef();

  const { userData, token, handleAuthExpiry } = useContext(AuthContext);

  const handleChange2 = (event) => {
    if (event.target.value === "Select Status") {
      setSelectedStatus2("Select Status");
      setQcPointsEmployee2(qcPointsEmployee);
    } else {
      setSelectedStatus2(event.target.value);
    }
  };

  useEffect(() => {
    if (selectedStatus2 === "Select Status") return;
    setQcPointsEmployee2(
      qcPointsEmployee?.filter((item) => item.Status === selectedStatus2)
    );
  }, [selectedStatus2]);

  function handleMonthChange(monthString) {
    setSelectedMonth(monthString);
  }

  const handleStatusChange = async (item, id, event) => {
    const newStatus = event.target.value;
    setStatuses((prevStatuses) => ({ ...prevStatuses, [id]: newStatus }));
    await editQcStatus(item, id, newStatus);
  };

  const fetchQcPointsEmployee = async (monthString) => {
    try {
      if (!token) return;

      // Extract year + month from yyyy-mm string
      const [year, month] = monthString.split("-");

      // Calculate 1st and last day of month
      const firstDay = `${year}-${month}-01`;
      const lastDay = `${year}-${month}-${new Date(year, month, 0)
        .getDate()
        .toString()
        .padStart(2, "0")}`;

      const response = await fetch(
        `${taskApiUrl}/GetControlPointMapping?DateRange1=${firstDay}&DateRange2=${lastDay}&Emids=${userData?.[0]?.EM_ID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 401) {
        await handleAuthExpiry();
        return;
      }

      const data = await response.json();

      if (Array.isArray(data)) {
        setQcPointsEmployee(data);
        setQcPointsEmployee2(data);

        const initialStatuses = data.reduce((acc, item) => {
          acc[item.Id] = item.Status;
          return acc;
        }, {});
        setStatuses2(initialStatuses);
      } else {
        toastRef.current.showToast("Something went wrong!", "error");
      }
    } catch (err) {
      console.error("fetchQcPointsEmployee error:", err);
      toastRef.current.showToast("Failed to load control points", "error");
    }
  };

  const editQcStatus = async (item, id, status) => {
    if (isGuestUser(userData?.[0]?.DRM_ID)) {
      toastRef.current.showToast(`Guest User Does not have Add or Edit Access`);
      return;
    }

    const currStatus =
      status === "P"
        ? "P"
        : status === "C"
        ? "C"
        : status === "NA"
        ? "NA"
        : "D";

    // Get current date-time in YYYY-MM-DDTHH:MM:SS format
    const now = new Date();
    const formattedDate =
      `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(now.getDate()).padStart(2, "0")}` +
      `T${String(now.getHours()).padStart(2, "0")}:${String(
        now.getMinutes()
      ).padStart(2, "0")}:${String(now.getSeconds()).padStart(2, "0")}`;

    const response = await fetch(`${taskApiUrl}/UpdateControlPointMapping`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        Id: item?.Id,
        EmpployeeId: item?.EmId,
        ControlPointId: item?.ControlPointId,
        Status: currStatus,
        AcceptedDate: formattedDate,
      }),
    });

    if (response?.status === 401) {
      await handleAuthExpiry();
      return;
    }

    const data = await response.json();
    if (data) {
      fetchQcPointsEmployee(selectedMonth);
      toastRef.current.showToast(
        "Control Point Saved Successfully!",
        "success"
      );
    } else {
      toastRef.current.showToast(
        "Something went wrong! Please try again",
        "error"
      );
    }
  };

  const currentEmployeeId = userData?.[0]?.EM_ID;

  useEffect(() => {
    if (!currentEmployeeId) return;
    fetchQcPointsEmployee(selectedMonth);
  }, [token, selectedMonth, currentEmployeeId]);

  const formatDateSafely = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return isNaN(date.getTime())
      ? dateString.split("T")[0]
      : date.toISOString().split("T")[0];
  };

  return (
    <div>
      <NavSub />
      <ToastComponent ref={toastRef} timeout={4000} />

      <div>
        <div className="qc-status-bar">
          <Box sx={{ width: 150 }}>
            <FormControl fullWidth>
              <Select value={selectedStatus2} onChange={handleChange2}>
                <MenuItem value={"Select Status"}>All</MenuItem>
                <MenuItem value={"P"}>Pending</MenuItem>
                <MenuItem value={"C"}>Completed</MenuItem>
                <MenuItem value={"NA"}>Not Applicable</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <input
            type="month"
            value={selectedMonth.slice(0, 7)}
            onChange={(e) => handleMonthChange(e.target.value)}
            className="calender_quality"
          />
        </div>

        {qcPointsEmployee2 && qcPointsEmployee2.length > 0 ? (
          qcPointsEmployee2.map((item) => {
            return (
              <div
                className="qc-status-card"
                key={item?.Id}
                style={{
                  borderLeft: `5px solid ${
                    item?.Status === "P"
                      ? "rgba(239, 160, 41, 1)"
                      : item?.Status === "C"
                      ? "green"
                      : item?.Status === "NA"
                      ? "red"
                      : item?.Status === "D"
                      ? "gray"
                      : "black"
                  }`,
                }}
              >
                <div className="qc-card-desc">
                  <div className="qc-card-control-points">
                    <div className="qc-card-control-point">
                      <div className="qc-card-bold-head">Control Points</div>
                      <div>{item?.ControlPoint}</div>
                    </div>
                    <div>
                      <div className="qc-card-bold-head">Key Control</div>
                      <div>{item?.Keycontrolsfor}</div>
                    </div>
                    <div>
                      <div className="qc-card-bold-head">Created Date</div>
                      <div>{formatDateSafely(item?.CreatedDate)}</div>
                    </div>
                    <div>
                      <div className="qc-card-bold-head">Accepted Date</div>
                      <div>{formatDateSafely(item?.AcceptedDate)}</div>
                    </div>
                    <div>
                      <div className="qc-card-bold-head">Due Date</div>
                      <div>{item?.DueDate && item.DueDate.split("T")[0]}</div>
                    </div>
                  </div>
                  <div className="qc-card-control-description">
                    <div className="qc-card-bold-head">Control Description</div>
                    <div>{item?.ControlDescription}</div>
                  </div>
                  <div className="qc-card-control-stats">
                    <div className="qc-card-control-stat">
                      <div className="qc-card-bold-head">TAT :</div>
                      <div>{item?.Tat}</div>
                    </div>
                    <div className="qc-card-control-stat">
                      <div className="qc-card-bold-head">Accuracy :</div>
                      <div>{item?.Accuracy}</div>
                    </div>
                    <div className="qc-card-control-stat">
                      <div className="qc-card-bold-head">Frequency :</div>
                      <div>{item?.Frequency}</div>
                    </div>
                    <div className="qc-card-control-stat">
                      <div className="qc-card-bold-head">Criticality :</div>
                      <div>{item?.Criticality}</div>
                    </div>
                  </div>
                </div>
                {!(item?.Status === "deleted") && (
                  <div className="qc-card-action">
                    <div className="qc-card-update-delete"></div>
                    <div className="qc-card-update-status">
                      <div className="qc-card-update-status-text">Status</div>
                      <div className="qc-card-update-status-text">
                        <Box sx={{ width: 150 }}>
                          <FormControl fullWidth>
                            <Select
                              value={item?.Status || "Select Status"}
                              onChange={(event) =>
                                handleStatusChange(item, item.Id, event)
                              }
                              sx={{
                                color:
                                  item?.Status === "P"
                                    ? "rgba(239, 160, 41, 1)"
                                    : item?.Status === "C"
                                    ? "green"
                                    : item?.Status === "NA"
                                    ? "black"
                                    : item?.Status === "Select Status"
                                    ? "gray"
                                    : "red",
                              }}
                            >
                              <MenuItem value={"Select Status"}>
                                Select Status
                              </MenuItem>
                              <MenuItem value={"P"}>Pending</MenuItem>
                              <MenuItem value={"C"}>Completed</MenuItem>
                              <MenuItem value={"NA"}>Not Applicable</MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div className="qc-no-data">
            No control points found for this month.
          </div>
        )}
      </div>
    </div>
  );
};

export default QualityControl;
